export class Entity {
    entity_name: string;
}
